module.exports = __webpack_public_path__ + "static/media/wings research.88f907ac.png";